
  import {BaseVue} from "@newview/base-web"
  import {Component, Prop, Watch} from "vue-property-decorator"
  import {vxeGrid, comForm, toolBar, customModal, comDetails} from "@newview/ui"
  import { AuthApi } from "@newview/system-api";

  @Component({
    components: {
      vxeGrid, comForm, toolBar, customModal, comDetails

    }
  })
  export default class RestPassword extends BaseVue {

    //#region 接口定义区
    authApi: AuthApi = new AuthApi()
    //#endregion 接口定义区
    resetPwdBoxState=1
    telNumber=""
    VerificationCode=""
    verifyCodeImg:any=""
    Verification_btn: any ="获取验证码"
    VerificationNoNext=true
    passWordNew=""
    passWordNewConfirm=""
    second = 300;
    //#endregion 变量定义区
    //#region 事件定义区
    mounted () {
    }
    

    VerificationFun(){
      if(this.telNumber==""){
        this.alert("请先输入手机号")
        return
      }else{
        if(!(/^1[3456789]\d{9}$/.test(this.telNumber))){
          this.alert("请输入正确的手机号码");
          return;
        }
      }
      this.authApi.sendCheckCode({userPhone:this.telNumber}).then(res=>{
          if(res.code==200){
            let result = setInterval(() => {
              --this.second;
              this.Verification_btn = '剩余'+this.second+'秒';
              if (this.second < 1) {
                clearInterval(result);
                this.second = 300;
                this.Verification_btn = "获取验证码";
              }
            }, 1000);
          }else{
            this.Verification_btn="获取验证码"
            this.alert(res.msg);
          }
      });
    }

    VerificationCodeChage(){
      if((/^\d{6}$/.test(this.VerificationCode))){
        this.VerificationNoNext=false
      }else{
        this.VerificationNoNext=true
      }
    }

    async findPassword(){
      if(this.passWordNew != this.passWordNewConfirm){
        return this.alert("两次输入密码不一致");
      }
      let param={
        newPassword:this.base64encode(this.passWordNew),
        confirmPassWord:this.base64encode(this.passWordNewConfirm),
        checkCode:this.VerificationCode,
        phone:this.telNumber
      }
      let res:any = await this.authApi.forgetPassword(param)
      if(res.code==200){
        this.alert("您已成功修改密码！","success");
        this.$emit("resetPwdSuccess",true)
      }else{
        this.alert(res.msg);
      }
    }

    //#endregion 方法定义区
  }
